export const fetchSignedURL = async (
    storage: firebase.storage.Storage,
    fileURL: string
) => {
    const signedURL = (await storage
        .refFromURL(fileURL)
        .getDownloadURL()) as string;
    return signedURL;
};
